export class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
        this.hasLoaded = false;
        this.observer = null;
    }

    connectedCallback() {
        if (this.hasLoaded || this.observer) return;

        requestAnimationFrame(() => {
            if (this.hasLoaded || this.observer || !this.dataset.url) return;

            this.observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    rootMargin: "0px 0px 200px 0px",
                },
            );
            this.observer.observe(this);
        });
    }

    handleIntersection(entries, observer) {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);
        this.hasLoaded = true;

        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(
                    "product-recommendations",
                );
                if (recommendations?.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }
}
